/* app/js/src/components/common/segment/segment.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
/*# sourceMappingURL=segment.component.css.map */
